import {
  Component,
  ViewChild
} from '@angular/core';
import {
  count,
  map
} from 'rxjs/operators';
import {
  Breakpoints,
  BreakpointObserver
} from '@angular/cdk/layout';
import {
  Observable,
  Subscription
} from 'rxjs';
import {
  NotifierService
} from '../../services/notifier/notifier.service';
import {
  Subject
} from 'rxjs';

import {
  takeUntil
} from 'rxjs/operators';

import {

  OnDestroy
} from '@angular/core';
import {
  MatTable,
  MatTableDataSource
} from '@angular/material/table';
import {
  MatPaginator
} from '@angular/material/paginator';
import {
  GlobalsService
} from 'src/app/services/globals/globals.service';
import {
  Howl,
  Howler
}
from 'howler';
import {
  UserModel
} from 'src/app/models/UserModel';
import {
  IncidentModel
} from 'src/app/models/IncidentModel';
import {
  MatSort
} from '@angular/material/sort';
import {
  ThingsModel
} from 'src/app/models/ThingsModel';
import {
  ApiService
} from 'src/app/services/api/api.service';
import {
  Router
} from '@angular/router';
// import {
//   ThingsComponent
// } from '../things/things.component';
// import {
//   UsersComponent
// } from '../users/users.component';
import {
  FormControl,
  FormGroup
} from '@angular/forms';
import {
  MatDialog
} from '@angular/material/dialog';
// import {
//   Map
// } from "mapbox-gl/dist/mapbox-gl"
// import * as mapboxgl from "mapbox-gl/dist/mapbox-gl"
import * as mapboxgl from 'mapbox-gl';
import {
  HeliumService
} from 'src/app/services/helium/helium.service';
import Plotly from 'plotly.js-dist'



//Setup jQuery
declare var google: any;
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-dash',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.scss'],

})
export class DashComponent implements OnDestroy {

  /** Based on the screen size, switch from standard to one column per row */

  //Locals : General
  private alarmSound: any = new Howl({
    src: ['assets/sound/woop_woop.mp3']
  });

  public showMinerVersion:boolean = true

  //Grid list behaviour
  public isHandSet: boolean = false;
  private destroyed = new Subject < void > ();
  private currentScreenSize: string;
  private breakpoints: number = 6
  public columns: number = 6;
  private gridByBreakpoint = {
    XLarge: 8,
    Large: 6,
    Medium: 4,
    Small: 2,
    XSmall: 1
  }
  private displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);


  //Map setup
  map: mapboxgl.Map;
  style = "mapbox://styles/mapbox/light-v10";
  lat = -33.923861;
  lng = 18.423085;
  markers: any[] = [];


  public overview: any = {
    synced: 0,
    online: 0,
    relayed: 0,
    total: 0
  };

  public firmware_version = [{
    name: "1.0.1",
    count: 0
  }]

  public firmware_version_1 = []

  public myFirmwareData = [];
  public fwData = [{
    values: [1, 2, 3, 4],
    labels: [],
    marker: {
      colors: [],
    },
    type: 'pie'
  }]

  public fwData_1 = [{
    values: [1, 2, 3, 4],
    labels: [],
    marker: {
      colors: [],
    },
    type: 'pie'
  }]






  constructor(private breakpointObserver: BreakpointObserver, private notifier: NotifierService, public globals: GlobalsService, private api: ApiService, private router: Router, public dialog: MatDialog, public heliumService: HeliumService) {


    //Determine screen size and handle breakpoints
    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
    ]).pipe(takeUntil(this.destroyed)).subscribe(result => {
      for (const query of Object.keys(result.breakpoints)) {
        if (result.breakpoints[query]) {
          //Screen size
          this.currentScreenSize = this.displayNameMap.get(query);

          //Set breakpoints
          this.breakpoints = this.gridByBreakpoint[this.currentScreenSize];
          this.isHandSet = this.breakpoints < 3 ? true : false
          this.columns = this.isHandSet ? 2 : 6
        }
      }
    });


  }

  //#region : Angular callbacks
  ngOnInit() {

    localStorage.setItem('lastpage', "dashboard");
    //Clean all data 
    this.clearData();
    this.globals.devicesLoading = true;

    //Fire api's
    this.getData();



    (mapboxgl as any).accessToken = "pk.eyJ1IjoiZGV3ZXRkdCIsImEiOiJja3czd3NoMGQwY2VtMnJtZTNiZmY5aGJpIn0.AndT8QDKejiR00UVLeCl3Q";

    this.map = new mapboxgl.Map({
      container: 'map',
      style: this.style,
      zoom: 13,
      center: [this.lng, this.lat],
      scrollZoom: false
    });


  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.map.resize();
      // Add map controls
      this.map.addControl(new mapboxgl.NavigationControl());
    }, 0);

  }

  ngOnDestroy() {}

  clearData() {
    //Helium Rewards
    this.globals.rewards = {
      total: {
        day: 0,
        week: 0,
        month: 0,
        total: 0
      }
    }
    this.globals.rewardsDayLoaded = false;
    this.globals.rewardsWeekLoaded = false;
    this.globals.rewardsMonthLoaded = false;
    this.globals.rewardsTotalLoaded = false;

    //Helium stats
    this.globals.synced = 0;
    this.globals.relayed = 0;
    this.globals.online = 0;
    this.globals.offline = 0;
    this.globals.statsloaded = false;


    //Helium devices
    this.globals.fullDeviceList = [];
  }

  async getData() {

    //Get Devices
    this.api.deviceList((devices: any) => {
      this.globals.devicesLoading = false;
      //Update devicelist
      this.globals.fullDeviceList = devices;

      //Get device stats
      this.getDeviceInfo(devices);

      //Get raw data stats


      //TODO: remove
      this.getFirmWareInfoMiner();
      this.getFirmWareInfoProton();


      this.getMapInfo(this)

    }, () => {
      this.globals.devicesLoading = false;
    })
  }


  //TODO: 
  getMapInfo(scope: any) {


    // this.markers = [{
    //     name: "Upbeat Seafoam Kookaburra",
    //     snr: "110991585000000139",
    //     coordinates: [-33.932422, 18.849560]
    //   },
    //   {
    //     name: "Melodic Opaque Salamander",
    //     snr: "110991585000000116",
    //     coordinates: [18.423085, -33.923861]
    //   },
    //   {
    //     name: "Late Cerulean Pheasant",
    //     snr: "110991585000000243",
    //     coordinates: [-33.923861, 18.423085]

    //   }
    // ];
    let markers = []
    for (let i = 0; i < scope.globals.fullDeviceList.length; i++) {
      let dev = scope.globals.fullDeviceList[i];

      //Get position from attributes

      let ind = this.globals.arrayFindWithAttr(dev.attributes, "name", "position");

      if (ind != -1) {
        let position = dev.attributes[ind].value;


        let marker = {
          name: dev.name,
          snr: dev.snr,
          coordinates: [position.lat, position.lng]
        }

        markers.push(marker)
      }

    }

    var bounds = new mapboxgl.LngLatBounds();

    for (const marker of markers) {

      //If coordinates
      if (marker.coordinates && marker.coordinates[0] && marker.coordinates[1]) {
        
      
      
      let mk = new mapboxgl.Marker({
        anchor: "bottom"
      })
        .setLngLat([marker.coordinates[1], marker.coordinates[0]])
        .setPopup(new mapboxgl.Popup().setHTML(`<div style='color:black'><h1 >${marker.name}</h1><br><div style="overflow-wrap: anywhere;">SNR:${marker.snr}</div><br>Lat:${marker.coordinates[0].toFixed(6)}<br>Lng:${marker.coordinates[1].toFixed(6)}</div>`)) // add popup
        .addTo(scope.map);

      let lat: number = marker.coordinates[0]
      let lng: number = marker.coordinates[1]
      bounds.extend([lng, lat])

    }

    }
    scope.map.fitBounds(bounds, {
      padding: 60
    });

    //zoom to fit 

    

  }

  async getFirmWareInfoMiner() {

    //Get different versions
    let devices = this.globals.fullDeviceList;

    //Initialise version options
    let fw_ver: any = {}

    for (let i = 0; i < devices.length; i++) {
      //Get fw version:  Helium
      let dev = devices[i];
      let attr = dev.attributes ? dev.attributes : [];

      let ind = this.globals.arrayFindWithAttr(attr, "name", "helium_fw_version");

      if (ind != -1) {
        let ver = attr[ind].value;

        if (typeof ver == "object") {
          ver = ver.version
        }

        //check if already added?
        if (fw_ver.hasOwnProperty(ver)) {
          //increment
          fw_ver[ver] += 1
        } else {
          // add and increment
          fw_ver[ver] = 1
        }
      }
    }

    //Build object
    let g_Ver = [];
    for (let v in fw_ver) {
      let ver = {
        name: v,
        count: fw_ver[v]
      }
      g_Ver.push(ver);
    }

    this.firmware_version = g_Ver

    let data = [{
      values: [],
      labels: [],
      marker: {
        colors: [],
      },
      type: 'pie'
    }]

    let chartColors = ['rgb(226, 185, 59)', 'rgb(0, 18, 49)', 'rgb(193, 90, 45)', 'rgb(189, 205, 217)']
    // build graph
    for (let i = 0; i < this.firmware_version.length ; i++) {
      let fwOption = this.firmware_version[i]

      //Only add if count >0


      if (fwOption && fwOption.count && fwOption.count > 0) {

      
          //Add label
          data[0].labels.push(fwOption.name)

          //Add Values
          data[0].values.push(fwOption.count)

          //Add Colors
          data[0].marker.colors.push(chartColors[i])
        
      }
    }

    this.fwData = data;

    var layout = {
      showlegend: false,
      // width: 600,
      maxwidth:'100%',
      height: 450,
      font: {
        size: 12
      },
      margin: {
        t: 10, //top margin
        l: 30, //left margin
        r: 30, //right margin
        b: 100 //bottom margin
      },
      // maxWidth:400
    };


    Plotly.newPlot('fw-versions', data, layout, {
      responsive: true
    });





  }

  async getFirmWareInfoProton() {

    //Get different versions
    let devices = this.globals.fullDeviceList;

    //Initialise version options
    let fw_ver: any = {}

    for (let i = 0; i < devices.length; i++) {
      //Get fw version:  Helium
      let dev = devices[i];
      let attr = dev.attributes ? dev.attributes : [];

      let ind = this.globals.arrayFindWithAttr(attr, "name", "proton_fw_version");

      if (ind != -1) {
        let ver = attr[ind].value;

        if (typeof ver == "object") {
          ver = ver.version
        }

        //check if already added?
        if (fw_ver.hasOwnProperty(ver)) {
          //increment
          fw_ver[ver] += 1
        } else {
          // add and increment
          fw_ver[ver] = 1
        }
      }
    }
    //Build object
    let g_Ver = [];
    for (let v in fw_ver) {
      let ver = {
        name: v,
        count: fw_ver[v]
      }
      g_Ver.push(ver);
    }

    this.firmware_version_1 = g_Ver

    let data = [{
      values: [],
      labels: [],
      marker: {
        colors: [],
      },
      type: 'pie'
    }]

    let chartColors = [ 'rgb(193, 90, 45)', 'rgb(189, 205, 217)','rgb(226, 185, 59)', 'rgb(0, 18, 49)']
    // build graph
    for (let i = 0; i < this.firmware_version_1.length && i < 3; i++) {
      let fwOption = this.firmware_version_1[i]

      //Only add if count >0


      if (fwOption && fwOption.count && fwOption.count > 0) {

       
          //Add label
          data[0].labels.push(fwOption.name)

          //Add Values
          data[0].values.push(fwOption.count)

          //Add Colors
          data[0].marker.colors.push(chartColors[i])
        
      }
    }

    this.fwData_1 = data;




    var layout = {
      showlegend: false,
      // width: 600,
      height: 450,
      font: {
        size: 12
      },
      margin: {
        t: 10, //top margin
        l: 30, //left margin
        r: 30, //right margin
        b: 100 //bottom margin
      },
      // padding:{r:100}
    };

    Plotly.newPlot('fw-versions-1', data, layout, {
      responsive: true
    });

  



  }

  getDeviceInfo(deviceList: any[]) {

    //Build rewards info
    this.getRewardsTotals(deviceList);

    //Update dash stats
    for (let i = 0; i < deviceList.length; i++) {
      let dev = deviceList[i];



      //Check online
      let lc = new Date(dev.lastcomms);
      let curr = new Date();

      let diff = curr.getTime() - lc.getTime();

      //also created != lastcomms
      let cr = new Date(dev.created);
      let flag = lc.getTime() - cr.getTime() > 10000 //Make sure lastcomms is bigger than created

      //If device has no comms in 60mins then it is offline
      if ((diff < (60*60000) && flag)) this.globals.online++; //60min

      //Check relayed
      let relayedInd = this.globals.arrayFindWithAttr(dev.attributes, "name", "relayed");
      relayedInd != -1 && dev.attributes[relayedInd].value ? this.globals.relayed++ : false;

      //Check synced
      // let syncedInd = this.globals.arrayFindWithAttr(dev.attributes, "name", "synced");
      // syncedInd != -1 && dev.attributes[syncedInd].value ? this.globals.synced++ : false;

      let minBInd = this.globals.arrayFindWithAttr(dev.attributes, "name", "miner_block_height");
      let minHInd = this.globals.arrayFindWithAttr(dev.attributes, "name", "helium_block_height");

      minBInd != -1 && dev.attributes[minBInd].value && minHInd != -1 && dev.attributes[minHInd].value && dev.attributes[minBInd].value / dev.attributes[minHInd].value * 100 > 99.98 ? this.globals.synced++ : false;


    }


  }

  getRewardsTotals(deviceList) {

    let day = 0;
    let week = 0;
    let month = 0;
    let total = 0;


    for (let i = 0; i < deviceList.length; i++) {
      let dev = deviceList[i];
      let attr = dev.attributes;

      //Get rewards attributes
      let ind = this.globals.arrayFindWithAttr(attr, "name", "rewards")

      if (ind != -1) {
        let rewards = attr[ind].value;

        day += rewards.day;
        week += rewards.week;
        month += rewards.month;
        total += rewards.total;

      } else {
        // console.log(1)
      }

    }

    //Set globally
    this.globals.rewards.total.day = day;
    this.globals.rewards.total.week = week;
    this.globals.rewards.total.month = month;
    this.globals.rewards.total.total = total;

  }

  toggleVersion(back:boolean = false) {

    if (back) {
      $('.carousel').carousel('prev');
     }
    else {
      $('.carousel').carousel('next');
    }

    window.dispatchEvent(new Event('resize'));

   
    $('.carousel').carousel('pause');
    this.showMinerVersion = !this.showMinerVersion;
  }
}
